'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isNumber3 = require('lodash/isNumber');

var _isNumber4 = _interopRequireDefault(_isNumber3);

exports.default = formDate;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDatetime = require('react-datetime');

var _reactDatetime2 = _interopRequireDefault(_reactDatetime);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _datePickerProps = require('./datePickerProps');

var _datePickerProps2 = _interopRequireDefault(_datePickerProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formDate(props) {
  // eslint-disable-next-line no-unused-vars
  var input = props.input,
      _props$meta = props.meta,
      touched = _props$meta.touched,
      error = _props$meta.error,
      type = props.type,
      disabled = props.disabled,
      placeholder = props.placeholder,
      required = props.required,
      allowPast = props.allowPast,
      inputProps = props.inputProps,
      other = (0, _objectWithoutProperties3.default)(props, ['input', 'meta', 'type', 'disabled', 'placeholder', 'required', 'allowPast', 'inputProps']);

  var datePickerProps = (0, _extends3.default)({}, _datePickerProps2.default);
  var finalInputProps = (0, _extends3.default)({}, datePickerProps.inputProps, inputProps, { required: required, disabled: disabled, placeholder: placeholder });

  if (allowPast) {
    datePickerProps.isValidDate = null;
  }

  if (input && input.value && (0, _isNumber4.default)(input.value)) {
    //the date from the server comes to the second format, need convert it to ms
    //todo: think about how to fix this
    if (input.value < Date.now() / 100) {
      input.value = new Date(input.value * 1000);
    }
  }

  // API dirty hack for wrong dates
  var dateYear = (0, _moment2.default)(input.value).year() || 0;
  if (input.value && input.value !== '1970-01-01' && dateYear > 1980) {
    input.value = (0, _moment2.default)(input.value);
  } else {
    // hide zero date (01/01/1970) in the date field
    input.value = '';
    datePickerProps.timeFormat = false;
    datePickerProps.dateFormat = '-';
  }

  var onFocus = function onFocus() {
    return finalInputProps.readOnly = true;
  };
  var onBlur = function onBlur() {
    return finalInputProps.readOnly = false;
  };

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_reactDatetime2.default, (0, _extends3.default)({}, input, datePickerProps, {
      inputProps: finalInputProps
    }, other, {
      disabled: disabled,
      onFocus: onFocus,
      onBlur: onBlur
    })),
    touched && error && _react2.default.createElement(
      'div',
      { className: 'fieldErrorText' },
      error
    )
  );
}

formDate.propTypes = {
  allowPast: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  input: _propTypes2.default.object,
  inputProps: _propTypes2.default.object,
  meta: _propTypes2.default.object,
  placeholder: _propTypes2.default.string,
  required: _propTypes2.default.bool,
  type: _propTypes2.default.string
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/formComponents/formDate.js
// module id = 524
// module chunks = 1